import { NATIVE_TOKEN_ADDRESS, WRAPPED_NATIVE_TOKEN_BY_CHAIN, } from '../configs/token';
export const toWrappedTokenFactory = (chainId) => {
    const wrappedNativeToken = WRAPPED_NATIVE_TOKEN_BY_CHAIN[chainId];
    return (token) => NATIVE_TOKEN_ADDRESS.toLowerCase() !== token.address.toLowerCase()
        ? token
        : wrappedNativeToken;
};
